// extracted by mini-css-extract-plugin
module.exports = {"status-filter":"FundTransfers_status-filter__2lPON","status-filter__active":"FundTransfers_status-filter__active__11ijR","sub-tab":"FundTransfers_sub-tab__1LckJ"};